export interface ExecuteSelection {
  indexId: string;
  videoIds: string[] | null;
}

export const getExecuteLocation = (indexId: string, videoIds?: string[]) => ({
  pathname: '/workflows',
  search: `?${new URLSearchParams({ index: indexId }).toString()}`,
  state: {
    executeSelection: {
      indexId,
      videoIds: videoIds === undefined ? null : Array.from(new Set(videoIds)).sort(),
    } satisfies ExecuteSelection,
  },
});
